module.exports = __webpack_public_path__ + "media/images/ic-diversos-menu-ea253dbb6f64d9f4b994c11de6c9ab85.svg";